import type { RateInfo } from '../../types/electricity'
import { RateGauge } from '../gauge/RateGauge'
import { CountdownTimer } from '../countdown/CountdownTimer'
import { QuickAdvice } from './QuickAdvice'

interface Props {
  rate: RateInfo
  onSeeMore?: () => void
}

export function HeroSection({ rate, onSeeMore }: Props) {
  return (
    <div className="glass-hero p-6 animate-fade-in-up">
      <RateGauge rate={rate} />
      <CountdownTimer rate={rate} />
      <QuickAdvice rate={rate} onSeeMore={onSeeMore} />
    </div>
  )
}
